import React, { ReactNode } from 'react';
import { toast, ToastContainer, TypeOptions } from 'react-toastify';

import ErrorIconSvg from '../assets/icons/toast-error-icon.svg?react';
import SuccessIconSvg from '../assets/icons/toast-success-icon.svg?react';

const TIMEOUT = 10000;
const NOTIFICATION_TOAST_CLASS_NAME = 'pp-notification-toast';
const NOTIFICATION_TOAST_CONTAINER_CLASS_NAME = 'pp-notification-toast-container';

const getToastClassName = (defaultClassName?: string, type?: TypeOptions) => {
  const typeClassName = type ? `${NOTIFICATION_TOAST_CLASS_NAME}--${type}` : '';

  return [defaultClassName, NOTIFICATION_TOAST_CLASS_NAME, typeClassName].filter(Boolean).join(' ');
};

export const NotificationsContainer = () => (
  <ToastContainer
    className={NOTIFICATION_TOAST_CONTAINER_CLASS_NAME}
    autoClose={TIMEOUT}
    position="top-center"
    hideProgressBar={true}
    closeOnClick
    closeButton={false}
    toastClassName={context => getToastClassName(context?.defaultClassName, context?.type)}
  />
);

export const showErrorToast = (content: string | ReactNode) => {
  const sanitizedContent =
    typeof content === 'string' ? content.replace(/GraphQL error:\s*/gi, '') : content;

  toast(sanitizedContent, {
    theme: 'colored',
    type: 'error',
    icon: <ErrorIconSvg />
  });
};

export const showSuccessToast = (content: string | ReactNode) => {
  toast(content, {
    theme: 'colored',
    type: 'success',
    icon: <SuccessIconSvg />
  });
};
